import {
  Button,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  pn,
} from "@compass/core";

import {
  Permission,
  PermissionAction,
  StudentPostHighSchoolListDto,
  StudentPostHighSchoolListFilter,
} from "generated/openApi";
import { useList, useRouter } from "hooks";
import { studentPostHighSchoolPageRoute } from "pages/students/student-post-high-schools/StudentPostHighSchoolPage/StudentPostHighSchoolPage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const PostHighSchools = (props: { initialLoad: boolean; studentId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.StudentPostHighSchool;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StudentPostHighSchoolListFilter>({
    postHighSchoolFilter: { studentId: props.studentId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<StudentPostHighSchoolListDto>("id"), isDesc: false }],
  });
  const [listItems, setListItems] = useState<StudentPostHighSchoolListDto[]>([]);

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.studentPostHighSchools.getList(listFilter).then((response) => {
        setListItems(response);
      });
    },
  });

  useEffect(() => {
    if (props.initialLoad) {
      loadList(listFilter);
    }
  }, [props.initialLoad]);

  return (
    <>
      <ListContainer
        fullHeight
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Post-HS Plans</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() =>
                    navigate({
                      pathname: studentPostHighSchoolPageRoute.getPath({
                        id: 0,
                        crudMode: "edit",
                        screenType: "dialog",
                      }),
                      search: studentPostHighSchoolPageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                      }),
                    })
                  }
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableBody>
                {listItems.map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: studentPostHighSchoolPageRoute.getPath({
                          id: listItem.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{listItem.college}</TableCell>
                    <TableCell>{listItem.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(studentPostHighSchoolPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
